import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-354ea2e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "e404" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "e404__elm" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "e404__elm-alert" }, "Ошибка 404. Страница не найдена.")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}